export default "__VITE_ASSET__BIX_oZU1__";